// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const AgencyEmployeeService = {};
function buildQuery(params) {
  return Object.entries(params)
    .filter(([_, v]) => v !== null && v !== undefined && v !== "")
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join("&");
}
AgencyEmployeeService.getAgencyEmployeeList = function (userInput) { 
  var userInputIndex = userInput.pageIndex || 0; 
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  const params = {
    pageSize: userInput?.pageSize ?? 20,
    pageIndex: decrementIndex ?? 0,
    agencyid: userInput?.agencyid,
    code: userInput?.code,
    name: userInput?.name,
    position: userInput?.position,
    // desc: userInput?.desc,
    // status: userInput?.status,
  };
  return lossClient({
    url: `/AgencyEmployee/search?${buildQuery(params)}`,
    method: "get",
  });
};

AgencyEmployeeService.getAgencyEmployeeApprovalList = function (userInput) {
  var userInputIndex = userInput.pageIndex;
  
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  
  return lossClient({
    url:
      "/AgencyEmployee/approvalAgencyEmployee?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&name=" +
      userInput.name +
      "&code=" +
      userInput.code +
      "&position=" +
      userInput.position,
    // "&status=" +
    // userInput.status,
    method: "get",
  });
};

// AgencyEmployeeService.getAgencyEmployeeDetail = function (data) {
//   return fetch({
//     url: `/AgencyEmployee/${data.id}`,
//     method: "get",
//   });
// };

AgencyEmployeeService.postAgencyEmployee = function (data) {
  return lossClient({
    url: "/AgencyEmployee/add",
    method: "post",
    data: data,
  });
};

AgencyEmployeeService.putAgencyEmployeeApproval = function (data) {
  const requestDataValidation =
    data.approvalFlag.toLowerCase() == "return"
      ? {
          UserId: data.userId,
          Note: data.note,
          AgencyId: data.AgencyId,
          AgencyEmployeeId: data.AgencyEmployeeId,
        }
      : data.approvalFlag.toLowerCase() == "reject"
      ? {
          UserId: data.userId,
          Note: data.note,
          AgencyId: data.AgencyId,
          AgencyEmployeeId: data.AgencyEmployeeId,
        }
      : data.approvalFlag == "approve"
      ? {
          UserId: data.userId,
          Note: data.note,
          AgencyId: data.AgencyId,
          AgencyEmployeeId: data.AgencyEmployeeId,
        }
      : {
          UserId: data.userId,
          Note: data.note,
          AgencyId: data.AgencyId,
          AgencyEmployeeId: data.AgencyEmployeeId,
        };

  let urlRequest;
  const requestUrlValdiation =
    data.approvalFlag.toLowerCase() == "return"
      ? (urlRequest = "return")
      : data.approvalFlag.toLowerCase() == "reject"
      ? (urlRequest = "reject")
      : data.approvalFlag == "approve"
      ? (urlRequest = "approve")
      : (urlRequest = "");

 
  return lossClient({
    url: `/AgencyEmployee/${urlRequest}`,
    method: "put",
    headers: {
      "x-requestId": data.id,
    },
    data: requestDataValidation,
  });
};

AgencyEmployeeService.putAgencyEmployeeRequest = function (data) {
 
  const { id, approvalFlag, ...bodyRequest } = data;
  return lossClient({
    url: `/AgencyEmployee/${data.approvalFlag}`,
    method: "put",
    headers: {
      "x-requestId": data.id,
    },
    data: bodyRequest,
  });
};

AgencyEmployeeService.updateAgencyEmployee = function (data) {
 
  const { id, ...requestBody } = data;
 
  return lossClient({
    url: "/AgencyEmployee/edit",
    method: "put",
    headers: {
      "x-requestId": data.id,
    },
    data: requestBody,
  });
};

AgencyEmployeeService.deleteAgencyEmployee = function (data) {
  const { id, ...requestBody } = data;
  return lossClient({
    url: "/AgencyEmployee/delete",
    method: "delete",
    headers: {
      "x-requestId": data.id,
    },
    data: requestBody,
  });
};

export default AgencyEmployeeService;
